<template>
  <div id="home">
    <div class="confirm-account-wrapper" style="max-width: 800px">
      <div class="wrapper-inner" style="width: 100%">
        <div class="action-box">
          <div class="box-content" v-if="started == false && interval == null">
            <img
              class="light-image"
              src="/static/img/illustrations/placeholders/launch.svg"
              alt=""
            />
            <img
              class="dark-image"
              src="/static/img/illustrations/placeholders/launch-dark.svg"
              alt=""
            />
            <h3 class="dark-inverted" style="font-size: 27px">
              {{ $t("speedtest.title") }}
            </h3>
            <p class="dark-inverted">
              {{ $t("speedtest.description") }}
            </p>
            <div class="buttons">
              <button
                @click="start"
                class="button h-button is-primary is-raised is-rounded"
              >
                {{ $t("speedtest.start") }}
              </button>
            </div>
          </div>
          <div class="box-content" v-if="started == false && interval != null">
            <h1
              style="font-size: 100px; font-weight: bold"
              class="dark-inverted"
            >
              {{ counter }}
            </h1>
          </div>

          <div class="box-content" v-if="started == true && ended == false">
            <p
              class="custom-content"
              v-html="content"
              style="
                text-align: left !important;
                font-size: 16px !important;
                color: black !important;
              "
            ></p>
            <button
              @click="end"
              class="button h-button is-primary is-raised is-rounded"
            >
              {{ $t("speedtest.bitti") }}
            </button>
          </div>

          <div class="box-content" v-if="started == true && ended == true">
            <p
              style="
                text-align: center;
                font-size: 36px;
                font-weight: bold;
                margin-bottom: 30px;
              "
              class="dark-inverted"
            >
              {{ $t("speedtest.speed") }}
              {{ Math.round((content.split(" ").length / timer) * 60) }}
              {{ $t("speedtest.kd") }}
              {{ $t("speedtest.time", { time: timer }) }}
            </p>
            <div
              class="questions"
              style="text-align: left"
              v-if="showQuestions"
            >
              <div class="question mb-3" v-for="(item, index) in questions">
                <h4
                  style="margin-bottom: 10px; font-size: 16px"
                  class="dark-inverted"
                >
                  {{ index + 1 }}- {{ item.title }}
                </h4>
                <label
                  class="radio"
                  v-for="option in item.answers.split(',')"
                  style="width: 100%; padding: 0px; margin-bottom: 10px"
                  :style="{
                    color: getOptionColor(index, option),
                  }"
                >
                  <input
                    type="radio"
                    :value="option"
                    v-model="questions[index].answer"
                    :disabled="calculated"
                  />
                  <span></span>
                  {{ option }}
                </label>
              </div>
            </div>
            <div v-else>
              <h3 class="text-center">
                {{ $t("speedtest.desc2") }}
              </h3>
              <h4 class="mb-3">
                {{ $t("speedtest.hatirlatma") }}
              </h4>
              <el-button type="primary" @click="showQuestions = true">{{
                $t("speedtest.sorularagec")
              }}</el-button>
              <el-button
                type="primary"
                @click="
                  ended = false;
                  begin();
                "
                >{{ $t("speedtest.metnedon") }}</el-button
              >
            </div>
            <div
              v-if="calculated"
              style="
                text-align: center !important;
                font-weight: bold !important;
                font-size: 40px !important;
              "
              class="dark-inverted"
            >
              {{ $t("speedtest.hesaplamatamam") }}<br />
              {{ $t("speedtest.anlamaorani") }}: %{{
                Math.round(
                  (questions.filter((k) => k.true_answer == k.answer).length /
                    questions.length) *
                    100
                )
              }}
              <br />
              <button
                @click="$router.back()"
                class="button h-button is-primary is-raised is-rounded"
              >
                {{ $t("speedtest.geri") }}
              </button>
            </div>
            <button
              v-if="
                !questions.some((k) => k.answer == null || k.answer == '') &&
                !calculated
              "
              @click="calculate"
              class="button h-button is-primary is-raised is-rounded"
            >
              {{ $t("speedtest.hesapla") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "SpeedTest",
  data() {
    return {
      counter: 3,
      interval: null,
      started: false,
      timer: 0,
      timerInterval: null,
      content: null,
      ended: false,
      questions: [],
      calculated: false,
      showQuestions: false,
    };
  },
  methods: {
    getOptionColor(index, option) {
      if (this.calculated == false) {
        return "";
      }

      if (this.questions[index].true_answer == option) {
        return "green";
      }

      if (
        this.questions[index].true_answer != option &&
        this.questions[index].answer == option
      ) {
        return "red !important";
      }
    },
    start() {
      this.interval = setInterval(() => {
        if (this.counter == 1) {
          clearInterval(this.interval);
          this.started = true;
          this.begin();
          return;
        }
        this.counter -= 1;
      }, 1000);
    },
    begin() {
      this.timerInterval = setInterval(() => {
        this.timer += 1;
      }, 1000);
    },
    end() {
      clearInterval(this.timerInterval);
      this.ended = true;
    },
    calculate() {
      var kelime = Math.round(
        (this.content.split(" ").length / this.timer) * 60
      );
      var anlama_orani = Math.round(
        (this.questions.filter((k) => k.true_answer == k.answer).length /
          this.questions.length) *
          100
      );

      if (anlama_orani < 50) {
        this.calculated = true;
        return;
      }

      axios
        .post("speedtest/save", { sure: this.timer, anlama_orani, kelime })
        .then((res) => {
          axios.get("account/get").then((res) => {
            this.$store.state.user = res.data.data.user;
          });
        });

      this.calculated = true;
    },
  },
  created() {
    this.$store.state.test_required_popup = false;
    axios.post("speedtest/getTest").then((res) => {
      this.content = res.data.data.content;
      this.questions = res.data.data.questions.map((k) => {
        return {
          ...k,
          answer: null,
        };
      });
    });
  },
};
</script>

<style lang="less">
.custom-content p {
  color: black !important;
  font-size: 16px !important;
  margin-bottom: 15px;
  font-family: Arial !important;
}

.is-dark {
  .custom-content p {
    color: white !important;
  }

  .custom-content strong {
    color: white !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/SpeedTest.vue